import BaseModel from 'src/model/base.model';

class BillingAddressModel extends BaseModel {
  public address: string = '';
  public address2: string = '';
  public city: string = '';
  public country: string = '';
  public fullBillingName: string = '';
  public requesterName: string = '';
  public state: string = '';
  public zipCode: string = '';
  public customerNumber: string = '';
}

export default BillingAddressModel;
